'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getTouchDistance = (touches)=>{
    const [touch1, touch2] = touches;
    return Math.hypot(touch2.clientX - touch1.clientX, touch2.clientY - touch1.clientY);
};
const getIsTouchPinch = (touches)=>{
    return touches.length === 2;
};

exports.getIsTouchPinch = getIsTouchPinch;
exports.getTouchDistance = getTouchDistance;
//# sourceMappingURL=touch.js.map
